import styled from 'styled-components'

export const AppealMethodsWrapper = styled.div`
	border: 1px solid #018d47;
	border-radius: 45px;
	max-width: 1440px;
	margin: 45px auto 100px auto;
`
export const AppealMethodsHeadline = styled.div`
	display: flex;
	align-items: center;
	gap: 80px;
	border-bottom: 1px solid #018d47;
	padding: 80px 49px 70px 60px;

	@media(max-width: 1024px) {
	 flex-direction: column;
	 gap: 10px;
	}

	@media(max-width: 768px) {
	 padding: 30px;
	}
	 @media(max-width: 425px) {
	 padding: 20px;
	}

	        
`
export const AppealMethodsTitle = styled.div`
	font-family: 'e-Ukraine-Head', sans-serif;
	font-weight: 400;
	font-size: 48px;
	color: #555;
	max-width: 700px;

	@media(max-width: 1024px) {
	 font-size: 24px;
	}

	@media(max-width: 425px) {
	 font-size: 20px;
	}
`
export const AppealMethodsText = styled.div`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 16px;
	line-height: 134%;
	color: #8f8f8f;
	max-width: 540px;

	@media(max-width: 1024px) {
	 font-size: 13px;
	 font-weight: 300;
	 max-width: 600px;
	}

	@media(max-width: 425px) {
	 font-size: 12px;
	}

`
export const AppealMethodsBody = styled.div``

export const Wrapper = styled.div`
	display: grid;
	grid-template-columns: 37.5% 1fr;
	overflow: hidden;

	@media(max-width: 768px) {
		grid-template-columns: 1fr;
	}
`

export const Left = styled.div`
	padding: 33px 10px 49px 84px;
	border-right: 1px solid #0a8f44;
	min-width: 0;

	@media(max-width: 1024px) {
	 padding: 33px 10px 49px 40px;
	}
	
	@media(max-width: 768px) {
	 padding: 33px 10px 15px 33px;
	}

	@media(max-width: 375px) {
	 padding: 15px 10px 15px 30px;
	}
`
export const MenuItem = styled.div<{ $active: boolean }>`
	position: relative;
	padding: 10px 14px 10px 18px;
	font-weight: 500;
	font-size: 18px;
	cursor: pointer;
	color: ${p => (p.$active ? 'white' : '#555')};
	background: ${p =>
		p.$active
			? 'linear-gradient(90deg,#0a8f44 0%, rgba(10,143,68,0.5) 50%, rgba(10,143,68,0) 100%)'
			: 'transparent'};

	border-radius: 4px;
	transition: all 0.25s ease;

	&:last-of-type {
		margin-bottom: 50px;
	}

	&::before {
		content: '';
		position: absolute;
		left: -20px;
		top: 0;
		bottom: 0;
		width: 6px;
		background: ${p => (p.$active ? '#0a8f44' : 'transparent')};
	}

	@media(max-width: 1024px) {
	  font-size: ${p => (p.$active ? '17px' : '15px')};
	}

	@media(max-width:768px) {

	&:last-of-type {
		margin-bottom: 0px;
	}
	}
`
export const Embla = styled.div`
	overflow: hidden;
`



export const Title = styled.h2`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 700;
	font-size: 32px;
	color: #555;

	display: flex;
	align-items: center;
	gap: 20px;

	@media(max-width: 1024px) {
	font-size: 24px;
	}

	@media(max-width: 425px) {
	margin: 0;
	}
`

export const Number = styled.span`
	font-family: 'e-Ukraine-Head', sans-serif;
	font-weight: 700;
	font-size: 36px;
	line-height: 140%;
	text-align: justify;
	color: #018d47;

	@media(max-width: 1024px) {
	font-size: 32px;
	}
`

export const List = styled.ul`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 16px;
	line-height: 121%;
	color: #555;
	margin-top: 20px;
	padding-left: 50px;

	li {
		margin-bottom: 8px;
	}

	li::marker {
		color: #018d47;
	}

	@media(max-width: 1024px) {
	 font-size: 13px;
	}

	@media(max-width: 425px) {
	padding-left: 25px;
	font-size: 12px;
	}
	
`
/*export const Right = styled.div`
	padding: 0px 0px 0px 82px;
	max-width: 100%;   
	min-width: 0; 

	@media(max-width: 1024px) {
	 padding: 0px 30px 0px 35px;
	}

	@media(max-width: 425px) {
	 padding: 0px 20px 0px 20px;
	}
`*/

export const Description = styled.p`
	margin-top: 10px;
	color: #555;
	padding-left: 50px;
	line-height: 1.6;
	max-width: 640px;

	@media(max-width: 1024px) {
	 font-size: 13px;
	 
	}

	@media(max-width: 425px) {
	padding-left: 10px;
	font-size: 12px;
	}
`
export const Phones = styled.ul`
	margin-top: 16px;
	margin-bottom: 10px;
	padding-left: 75px;
	display: grid;
	grid-template-columns: repeat(2, auto);
	gap: 8px 60px;

	li {
		list-style: disc;
		color: #333;
	}
		@media(max-width: 1024px) {
	 font-size: 13px;
	 grid-template-columns: repeat(1, auto);
	}
`

export const ButtonContainer = styled.div`
  display: flex;
	justify-content: center;
	margin-top: 30px;
`


export const Right = styled.div`
  padding: 33px 0px 33px 82px;  
  max-width: 100%;
  min-width: 0;

  @media(max-width: 1024px) {
    padding: 20px 30px 20px 35px;
  }

  @media(max-width: 425px) {
    padding: 15px 20px 15px 20px;
  }
`

export const EmblaContainer = styled.div`
  display: flex;
  align-items: flex-start; 
`



export const EmblaSlide = styled.div<{ $active: boolean }>`
  display: ${props => props.$active ? 'block' : 'none'};
  opacity: ${props => props.$active ? 1 : 0};
  transition: opacity 0.4s ease;
  animation: ${props => props.$active ? 'fadeIn 0.4s ease' : 'none'};

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(8px); }
    to { opacity: 1; transform: translateY(0); }
  }
`